import { render } from "./Loading.vue?vue&type=template&id=3658a915&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=3658a915&scoped=true&lang=css"

import exportComponent from "/Users/Alexandre-OlivierRenaud/formateurs-autorises/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3658a915"]])

export default __exports__